import Jaws from '@modules/three/common/Jaws.ts';
import JawExport from '@export/three/JawExport.ts';
import type { JawsCorrectionResponse } from '@/schema/JawsCorrection';
import { upperFDI, lowerFDI } from '@/common/FDI_Notation';

export default class JawsExport extends Jaws {
  public lowerJaw: JawExport;
  public upperJaw: JawExport;

  constructor(lowerJaw: JawExport, upperJaw: JawExport) {
    super(lowerJaw, upperJaw);
    this.lowerJaw = lowerJaw;
    this.upperJaw = upperJaw;
  }

  public applyCorrection(correction: JawsCorrectionResponse) {
    const lowerTarget = this.detectTargetJaw(correction.lowerJaw.teethCorrection);
    const upperTarget = this.detectTargetJaw(correction.upperJaw.teethCorrection);

    const lowerCorrections = correction.lowerJaw.teethCorrection;
    const upperCorrections = correction.upperJaw.teethCorrection;

    if (lowerTarget === 'upper') {
      console.warn('[JawsExport] lowerJaw corrections look like upper teeth (FDI swap detected). Applying to upper jaw.');
      this.upperJaw.applyToothCorrections(lowerCorrections);
    } else {
      this.lowerJaw.applyToothCorrections(lowerCorrections);
    }

    if (upperTarget === 'lower') {
      console.warn('[JawsExport] upperJaw corrections look like lower teeth (FDI swap detected). Applying to lower jaw.');
      this.lowerJaw.applyToothCorrections(upperCorrections);
    } else {
      this.upperJaw.applyToothCorrections(upperCorrections);
    }

    if (correction.upperJaw.gumBoundaryIndices) {
      this.upperJaw.setGumBoundaryIndices(correction.upperJaw.gumBoundaryIndices);
    }
    if (correction.lowerJaw.gumBoundaryIndices) {
      this.lowerJaw.setGumBoundaryIndices(correction.lowerJaw.gumBoundaryIndices);
    }
  }

  private detectTargetJaw(corrections: JawsCorrectionResponse['upperJaw']['teethCorrection']) {
    let upperCount = 0;
    let lowerCount = 0;
    corrections.forEach((correction) => {
      if (upperFDI.includes(correction.fdi as any)) {
        upperCount += 1;
      } else if (lowerFDI.includes(correction.fdi as any)) {
        lowerCount += 1;
      }
    });
    if (upperCount === 0 && lowerCount === 0) {
      return 'lower';
    }
    return upperCount >= lowerCount ? 'upper' : 'lower';
  }

  public dispose() {
    this.lowerJaw.dispose();
    this.upperJaw.dispose();
    this.removeFromParent();
  }
}

